import { Navigate } from "react-router-dom";
import useDataset from "datasets/hooks/useDataset";
import usePermissions from "datasets/hooks/usePermissions";
import Loading from "~/components/Loading";
import { ROUTE_404 } from "~/router/constants";
import { AddTable } from "./tables/AddTable";

export const DatasetAddTable = () => {
  const { isLoading } = useDataset();
  const canCreate = usePermissions("create:catalog-ingest");
  if (isLoading) {
    return <Loading />;
  }
  if (!canCreate) {
    return <Navigate to={ROUTE_404} replace />;
  }
  return <AddTable />;
};
